import { render, staticRenderFns } from "./chip-primary.vue?vue&type=template&id=78e07f92&scoped=true&"
import script from "./chip-primary.vue?vue&type=script&lang=js&"
export * from "./chip-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e07f92",
  null
  
)

export default component.exports